import { connect } from 'react-redux';
import { getUnits } from '../../../../reducers/analyticsApp';
import ManagerUnitCard from '../../../../components/dashboards/cards/create/ManagerUnitCard';

const mapStateToProps = (state, { id }) => ({
  unit: getUnits(state).find((unit) => unit?.id === id),
});

export default connect(mapStateToProps)(ManagerUnitCard);
